import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { AttachmentsService } from '@pt/api-client';
import { IconType, IoniconsOutline, ND } from '@pt/pt-models';
import { Attachment } from 'it/primatoo/openapi/api/org/schemas/common/Attachment';


@Component({
  selector: 'pt-details-attachments',
  templateUrl: 'details-attachments.component.html',
  styleUrls: [`details-attachments.component.scss`]
})

export class DetailsAttachmentsComponent implements OnChanges {
  @ViewChild('collapse') collapse;
  @Input() attachments: Attachment[];
  public iconType = IconType.IONIC_ICON;
  public iconArrow = IoniconsOutline.arrowDown;
  public iconSize = 12;
  public enableExpand = false;
  public isCollapsedOtherAttributes = true;
  public ND = ND;
  public SVG = IconType.SVG;

  constructor(private attachmentsService: AttachmentsService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.attachments) {
      const currentAttachments: Attachment[] = changes.attachments?.currentValue;
      this.enableExpand = currentAttachments?.length > 3;
    }
  }

  downloadAttachment(attachment: Attachment) {
    this.attachmentsService.downloadAttachment(attachment, attachment.attachmentType);
  }
}
